export const REGISTRATION_FIELD_KEYS = {
  email: 'email',
  iddNumber: 'iddNumber',
  agentNumber: 'agentNumber',
  firstName: 'firstName',
  lastName: 'lastName',
  companyName: 'companyName',
  phoneMobile: 'phoneMobile'
};